<div class="max-w-1024 w-full fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-modal">
  <div class="p-16">
    <div class="
      border-none
      shadow-lg
      relative
      flex
      flex-col
      w-full
      bg-white
      rounded-md
      outline-none
      text-current
    ">
      <ng-content></ng-content>
    </div>
  </div>
</div>
